import { Component, Inject, Input, OnInit } from '@angular/core';
import { PresentUserData } from '@/app/platform/platform-data/models/present-user-data';
import { DataTableHeader } from '@shared/tables/components/e-simple-data-table/e-simple-data-table.component';
import {
  PRESENT_DEVICE_USER_ACTIONS,
  PresentDeviceUserActions
} from '@/app/platform/platform-data/actions/types';
import { Confirmer, CONFIRMER } from '@shared/components/dialogs/confirm/types';

@Component({
    selector: 'present-users-table[presentUsers]',
    templateUrl: './present-users-table.component.html',
    styleUrls: ['./present-users-table.component.scss'],
    standalone: false
})
export class PresentUsersTableComponent implements OnInit {
  @Input() presentUsers: PresentUserData[];

  constructor(
    @Inject(PRESENT_DEVICE_USER_ACTIONS)
    private readonly presentDeviceUserActions: PresentDeviceUserActions,
    @Inject(CONFIRMER)
    private readonly confirmer: Confirmer
  ) {}

  readonly headers: DataTableHeader<PresentUserData>[] = [
    {
      key: 'lastChangedOn',
      label: 'Laatst gewijzigd'
    },
    {
      key: 'displayName',
      label: 'Naam'
    },
    {
      key: 'deviceDisplayName',
      label: 'Toestel'
    },
    {
      key: 'status',
      label: 'Status'
    }
  ];

  ngOnInit(): void {}

  async onInvalidate(presentUser: PresentUserData) {
    const confirmation = await this.confirmer.confirm(
      'Ben je zeker dat je deze persoon wil afmelden?',
      { color: 'danger' }
    );

    if (confirmation) {
      const result = await this.presentDeviceUserActions.forceInvalidate(presentUser.id);
    }
  }

  async onStop(presentUser: PresentUserData) {
    const confirmation = await this.confirmer.confirm(
      'Ben je zeker dat je de tijdsregistratie voor deze gebruiker wil beëindigen?',
      { color: 'danger' }
    );
    if (confirmation) {
      const result = await this.presentDeviceUserActions.forceStop(presentUser.id);
    }
  }
}
